import { createReducer, on } from "@ngrx/store"
import { createHistoriqueScan, createHistoriqueScanFailure, createHistoriqueScanSuccess, getAllHistoriqueScan, getAllHistoriqueScanFailure, getAllHistoriqueScanSuccess } from "../actions/historiqueScan.action"

export interface HistoriqueState {
  historiqueStates: any
}


export const initialState: HistoriqueState = {
  historiqueStates: {
    content: [],
    totalPages: 0,
    totalElements: 0,
    pageable: {
      pageNumber: 0,
      pageSize: 20
    }
  }
}

export const historiqueScanReducer = createReducer(
  initialState,
  on(createHistoriqueScan, (state) => ({ ...state })),
  on(createHistoriqueScanSuccess, (state, { reponseDAO }) => ({ ...state, reponseDAO })),
  on(createHistoriqueScanFailure, (state, { error }) => ({ ...state, error })),
  on(getAllHistoriqueScan, (state) => ({ ...state })),
  on(getAllHistoriqueScanSuccess, (state, reponseDAO) => ({ ...state, reponseDAO })),
  on(getAllHistoriqueScanFailure, (state, { error }) => ({ ...state, error }))
)


